module.exports = __webpack_public_path__ + "img/about_logo_07.1beb8ed0.png";